import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { catchError, debounceTime, map, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { Natjecaj, PostanskiUred, Root } from 'src/app/model';

import { PodrucjePrijave, Prijavnica, Zupanije } from 'src/app/post.model';
import { environment } from 'src/environments/environment';


interface ApiResponse<T> {
  status: string;
  message: string;
  data?: T; // `data` može biti PrijavnicaDto ili `undefined` ako nije vraćeno
}



const statusiTokenPoruke: string[] = [ "EXISTS" , "EXPIRED" , "INVALID" , "VALID"];
const statusiSpremanjaPoruka: string[] = ["ERROR", "EXISTS"];

@Injectable({ providedIn: 'root' })
export class PostsService {
  public url: string = environment.API_URL;

  public env: string = environment.env;
  oibServiceData: string = '';
  oibUrl: string = this.oibServiceData;
  // oib_url: string = //
  // 'http://hep-devapps:8080/oibservice-back/api/oib/call-soap?oibKorisnika=28921978587'
  //'https://energyplaner.hep.hr/oibservice/api/oib/call-soap?oibKorisnika=28921978587';
  expires: string = '';
  godine: string = '';
  email: string = '';
  podrucjePrijave?: PodrucjePrijave;
  podrucjeNaziv: string = '';
  natjecaj!: Natjecaj;


  showAll: boolean = false!;
  tokenStatus: string = '';
  tokenPoruka: string = '';
  spremanjeStatus: string = '';
  spremanjePoruka: string = '';
  porukaMail: string = '';

 status :string ='';
  constructor(private http: HttpClient) {}

  spremiprijavnica(prijavnica: FormData): Observable<ApiResponse<any>> {
    return this.http
      .post<ApiResponse<any>>(`${this.url}api/set/saveprijavnica1`, prijavnica)
      .pipe(
        catchError((err) => {
          let status = 'ERROR';
          let message = 'Došlo je do neočekivane pogreške.';
           let details: string | undefined;

          if (err.error && typeof err.error === 'object') {
            status =  'ERROR';
            message = err.error.message || message;
             details = err.error.details ||err.error.status; // npr. stack trace ili dodatne info
          } else if (typeof err.error === 'string') {
            message = err.error;
          }

          this.spremanjeStatus = status;
          this.spremanjePoruka = message;

           console.error('Greška pri slanju prijavnice:', {
          status,
          message,
          details,
          httpStatus: err.status,
          errorResponse: err.error,
        });


          return throwError(() => new Error(`${status}: ${message}`));
        })
      );
  }

  //vraćamo error u status i message
  validateToken(token: string): Observable<ApiResponse<any>> {
    return this.http
      .get<ApiResponse<any>>(`${this.url}auth/validate-link?token=${token}`, {})
      .pipe(
        catchError((err) => {
          const errorResponse: ApiResponse<any> = err.error;
          this.tokenStatus = errorResponse.status;
          this.tokenPoruka = errorResponse.message;

          return throwError(
            () => new Error(`${errorResponse.status}: ${errorResponse.message}`)
          );
        })
      );
  }

  existsOib = false!;

  getExistsOib(oib: string): Observable<ApiResponse<any>> {
    return this.http
      .get<ApiResponse<any>>(`${this.url}api/get/exists/oib/${oib}`)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 409) {
            // OIB postoji, vrati ApiResponse iz tijela odgovora
            return of(error.error as ApiResponse<any>);
          }
          // Ostale greške proslijedi dalje
          return throwError(
            () => new Error('Došlo je do greške prilikom provjere OIB-a.')
          );
        })
      );
  }

  sendEmailService(email: string, adresa: string) {
    return this.http.post(
      `${this.url}auth/sendEmail?email=${email}&adresa=${adresa}`,
      this.porukaMail,
      { responseType: 'text' }
    );
  }

  getOibUrl(): Observable<string> {
 
    return this.http.get<string>(`${this.url}api/config/${this.env}`);
  }

  getOibData(oib: string): Observable<Root> {
    return this.http.get<Root>(`${this.oibUrl}&oib=${oib}`);
  }

  getGodineDonacija(
    oib: string,
    godina: number,
    n: number
  ): Observable<string> {
    return this.http.get(
      `${this.url}api/get/godinedonacija?oib=${oib}&godina=${godina}&n=${n}`,
      { responseType: 'text' }
    ); // Ekstrahiraj vrijednost iz JSON-a
  }

  getGodineService(oib: string, godina: number, n: number) {
    this.godine = '';
    this.getGodineDonacija(oib, godina, n).subscribe(
      (response: any) => {
        try {
          const parsedData = JSON.parse(response);
          this.godine = parsedData; // Ako je response već JSON, ovo će izazvati grešku.
          
        } catch (e) {
          console.error('JSON parsing error:', e);
        }
      },
      (error) => {
        console.error('HTTP Error:', error);
      }
    );
  }

  //  /api/get/podrucjePrijave/all
  getPodrucjePrijave(): Observable<PodrucjePrijave[]> {
    return this.http.get<PodrucjePrijave[]>(
      `${this.url}/api/get/podrucjePrijave/all`
    );
  }


  //  /api/get/podrucjePrijave/all
  getZupanije(): Observable<Zupanije[]> {
    return this.http.get<Zupanije[]>(
      `${this.url}/api/get/zupanije/all`
    );
  }
  ///api/natjecaji/desc
  getAktivanNatjecaj(): Observable<Natjecaj> {
    return this.http.get<Natjecaj>(`${this.url}api/get/natjecaj/aktivan`);
  }



  ///api/natjecaji/desc
  getNatjecajGodina(godina: number): Observable<Natjecaj> {
    return this.http.get<Natjecaj>(`${this.url}api/get/natjecaj/godina/${godina}`);
  }
 // GET /api/get/ptbr/10000
//

  dohvatiPoPtbr(ptbr: string): Observable<PostanskiUred> {
    return this.http.get<PostanskiUred>(`${this.url}api/postanski-podaci/ptbr/${ptbr}`);
  }
}
